<template>
    <div>
        <div class="accordion-item">
            <h2 class="accordion-header" id="panelsStayOpen-headingTwo">
                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                Food security
                </button>
            </h2>
            <div id="panelsStayOpen-collapseTwo" class="accordion-collapse collapse show" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                <div class="accordion-body">
                    <ul class="nav flex-column">
                        <li class="nav-item">
                            <router-link to="/foodsecure/1" class="nav-link">Xayaburi and Don Sahong</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/foodsecure/2" class="nav-link">Xayaburi, Don Sahong, and Pak Beng</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/foodsecure/3" class="nav-link">Xayaburi, Don Sahong, Pak Beng and Sanakham</router-link>
                        </li>
                        <li class="nav-item">
                                <router-link to="/foodsecure/4" class="nav-link">Xayaburi, Don Sahong, Pak Beng, Sanakham and Luang Prabang</router-link>
                        </li>
                        <li class="nav-item">
                                <router-link to="/foodsecure/5" class="nav-link">All planned dams</router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>